import "../../styles/quote-details-items.css";

import { Button } from "@tql/ui-components-react/tql/buttons";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";
import { useContext, useState } from "react";

import { convertCommodityToHandlingUnit } from "~/features/quote/utils/commodity-to-handling-unit.ts";
import { SavedCommoditiesModal } from "~/shared/components/commodities/saved-commodities-modal.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";
import {
	ddUseSavedCommodity,
	toDdWorkflow,
} from "~/shared/utils/datadog-actions.ts";

import { QuoteDetailsContext } from "../../../../context/quote-details-context.tsx";

const unitOptions = [
	{ text: "Imperial (lb / in)", value: "LB/IN" },
	{ text: "Metric (kg / cm)", value: "KG/CM" },
];

type CommodityToolbarProps = {
	hideSavedCommodities?: boolean;
};

export const CommodityToolbar = ({
	hideSavedCommodities = false,
}: CommodityToolbarProps) => {
	const { quoteState, addItem, removeAllBlankItems, onChange, workflow } =
		useContext(QuoteDetailsContext);

	const { isEnabled: isUnitConversionEnabled, isReady: isUnitConversionReady } =
		useFeatureFlagGate("traxLtlUnitConversion");

	const [showQuoteCommoditiesModal, setShowQuoteCommoditiesModal] =
		useState(false);

	return (
		<>
			{!hideSavedCommodities && (
				<SavedCommoditiesModal
					customerId={quoteState.customer?.id}
					onSetSelectedItems={(selectedItems) => {
						if (hideSavedCommodities) return;
						for (const item of selectedItems) {
							addItem(
								convertCommodityToHandlingUnit(item, quoteState.measuringType),
							);
						}
						removeAllBlankItems();
						ddUseSavedCommodity(toDdWorkflow(workflow));
					}}
					onToggleModal={() => setShowQuoteCommoditiesModal(false)}
					showModal={showQuoteCommoditiesModal}
				/>
			)}
			<div className={"commodities-header-row"}>
				<h4>Commodities</h4>
				<div id={"saved-items-row"}>
					{hideSavedCommodities ? null : (
						<div className={"commodity-action-button"}>
							<Button
								disabled={!quoteState.customer || quoteState.customer.id == 0}
								formAction={"none"}
								onClick={() => setShowQuoteCommoditiesModal(true)}
								tabIndex={-1}
							>
								Saved Commodities
							</Button>
						</div>
					)}

					{isUnitConversionReady && isUnitConversionEnabled ? (
						<DropDownList
							className={"imperial-metric-dropdown"}
							data={unitOptions}
							data-testid={"top-unit-dropdown"}
							id={`unit-dropdown`}
							onChange={({
								value,
							}: {
								value: { text: string; value: string };
							}) => {
								onChange("measuringType", value.value);
							}}
							textField={"text"}
							value={unitOptions.find(
								(option) => option.value === quoteState.measuringType,
							)}
							valueField={"value"}
						/>
					) : null}
				</div>
			</div>
		</>
	);
};
